<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<!-- Main nexleader-wrapper -->
<div id="nexleader-wrapper">
  <div class="content animate-panel">
    <div class="row">
      <!-- Top section: Six Archetypes e-book promo (replaces the older    -->
      <!-- Grow Toward Your Dreams book promo per Steve 2026-06-11 item 4). -->
      <div class="col-md-12">
        <div class="hpanel">
          <div class="panel-body">
            <div class="row">
              <div class="col-sm-4 text-center">
                <a href="assets/ebook/the-six-archetypes.pdf" target="_blank" rel="noopener">
                  <img src="assets/ebook/six-archetypes-cover.png"
                       alt="The Six Archetypes — A Self-Leadership Operating System"
                       style="max-width: 240px; width: 100%; height: auto; box-shadow: var(--shadow-card-hover); border-radius: 4px;" />
                </a>
              </div>
              <div class="col-sm-8">
                <h3 class="font-bold m-b-sm" style="color: var(--c-green-deep);">
                  The Six Archetypes
                </h3>
                <h5 class="text-muted m-t-none m-b-md" style="letter-spacing: 1px; text-transform: uppercase;">
                  A Self-Leadership Operating System
                </h5>
                <p class="m-b-md text-lg">
                  Go deeper on the framework behind your IPSAT 2.0 archetype report. This
                  free e-book explores how each of the six archetypes operates, the
                  contribution patterns they bring, and how to grow into the fullest
                  expression of your identity profile.
                </p>
                <a href="assets/ebook/the-six-archetypes.pdf" target="_blank" rel="noopener"
                   class="btn btn-success btn-lg">
                  <i class="fa fa-download"></i>&nbsp;&nbsp;Download the E-book (PDF)
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Pre-assessment input cards (Personality / Strengths / Skills /     -->
      <!-- Spiritual Gifts or Values / Passions). Each category becomes its  -->
      <!-- own tappable card; the *ngIf on the outer .hpanel guards against -->
      <!-- empty cards rendering for categories with no matching prereq.    -->
      <div class="col-md-12" *ngIf="user['prerequisites']">
        <div class="row preassessment-grid">
          <ng-container *ngFor="let category of categories">
            <ng-container *ngFor="let _prereq of user['prerequisites'] | keyvalue : onCompare">
              <div class="col-md-15" *ngIf="_prereq.key === category.prerequisite">
                <div class="hpanel card-tappable">
                  <div class="panel-body">
                    <div class="m-b-sm">
                      <span class="icon-circle"
                            [ngClass]="{
                              'ic-personality': category.name === 'Personality',
                              'ic-strengths':   category.name === 'Strengths',
                              'ic-skills':      category.name === 'Skills',
                              'ic-gifts':       category.name === 'Spiritual Gifts',
                              'ic-passions':    category.name === 'Passions'
                            }">
                        <i class="fa"
                           [ngClass]="{
                             'fa-user':         category.name === 'Personality',
                             'fa-star':         category.name === 'Strengths',
                             'fa-lightbulb-o':  category.name === 'Skills',
                             'fa-bolt':         category.name === 'Spiritual Gifts',
                             'fa-puzzle-piece': category.name === 'Passions'
                           }"></i>
                      </span>
                    </div>
                    <h5 class="font-bold m-t-none m-b-xs" *ngIf="category.prerequisiteName !== 'Top 3'">
                      {{ category.prerequisiteName }}
                    </h5>
                    <h5 class="font-bold m-t-none m-b-xs" *ngIf="category.name === 'Skills'">
                      Skills Inventory (Top 3)
                    </h5>
                    <h5 class="font-bold m-t-none m-b-xs" *ngIf="category.name === 'Passions'">
                      MyPassionsProfile.com (Top 3)
                    </h5>
                    <h5 class="font-bold m-t-none m-b-xs" *ngIf="
                        category.name === 'Spiritual Gifts' &&
                        surveyType === 'values_based'
                      ">
                      Personal Values (Top 3)
                    </h5>
                    <h5 class="font-bold m-t-none m-b-xs" *ngIf="
                        category.name === 'Spiritual Gifts' &&
                        surveyType === 'faith_based'
                      ">
                      Spiritual Gifts (Top 3)
                    </h5>
                    <p class="text-muted m-b-sm" *ngIf="_prereq.value.name">{{ _prereq.value.name }}</p>
                    <p class="text-muted m-b-sm" *ngIf="_prereq.value[0]">
                      <span *ngFor="let v of _prereq.value; let last = last">
                        <span class="word-wrap">{{ v.name
                          }}<span *ngIf="v.level"> ({{ v.level.name }})</span><span *ngIf="!last">, </span></span>
                      </span>
                    </p>
                    <div class="text-right">
                      <span class="drill-link"><i class="fa fa-arrow-right"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="col-md-12" *ngIf="!user['prerequisites']">
        <div class="hpanel">
          <h4>No prerequisites yet.</h4>
        </div>
      </div>
      <div class="col-md-12 m-b-lg" *ngIf="ipsatResults.length < 1">
        <h4>No IPSAT assessment results yet.</h4>
      </div>
      <div class="col-md-12" *ngFor="let result of ipsatResults">
        <div class="hpanel">
          <div class="panel-body" style="padding: 0; overflow: hidden;">
            <div class="row" style="margin: 0;">
              <!-- Score Breakdown (left) -->
              <div
                [class]="hasArchetypeReport(result._id) ? 'col-sm-5' : 'col-sm-12'"
                style="padding: 30px;"
              >
                <div class="text-center" [ngStyle]="doughnutStyle">
                  <small class="text-muted">{{ possessivePrefix }} Score Breakdown</small>
                  <br /><br />
                  <canvas #canvas id="doughnut{{ result._id }}"></canvas>
                </div>
                <div class="text-center m-t-md">
                  <p class="score-value font-extra-bold" style="margin-bottom: 2px;">
                    {{ result.total }}
                  </p>
                  <small class="text-muted">IPSAT score out of 100</small>
                </div>
                <!-- IPSAT 2.0 Upsell (no archetype report yet) -->
                <div class="m-t-md text-center" *ngIf="!hasArchetypeReport(result._id) && canPurchaseArchetypeReport">
                  <hr />
                  <p class="text-muted m-b-sm">
                    <i class="fa fa-lightbulb-o text-warning"></i>&nbsp;&nbsp;
                    Discover {{ possessivePrefix }} leadership archetype
                  </p>
                  <button class="btn btn-success btn-sm" (click)="openPurchaseModal(result)">
                    <i class="fa fa-star"></i>&nbsp;&nbsp;Unlock IPSAT 2.0
                  </button>
                </div>
              </div>
              <!-- Archetype Wheel (right) — only when report exists -->
              <div
                class="col-sm-7"
                *ngIf="hasArchetypeReport(result._id)"
                style="padding: 30px; background: linear-gradient(135deg, #f7faf8 0%, #eef5f0 100%); border-left: 3px solid var(--c-green); display: flex; flex-direction: column; align-items: center; justify-content: center;"
              >
                <div style="max-width: 380px; width: 100%;">
                  <div class="text-center m-b-sm">
                    <span class="label label-success text-xs" style="letter-spacing: 0.5px;">
                      <i class="fa fa-star"></i>&nbsp;&nbsp;IPSAT 2.0 ARCHETYPE
                    </span>
                  </div>
                  <app-archetype-wheel
                    [primary]="getArchetypeReport(result._id)?.archetype?.primary || ''"
                    [secondary]="getArchetypeReport(result._id)?.archetype?.secondary || ''"
                  ></app-archetype-wheel>
                  <div class="text-center m-t-sm">
                    <h4 class="font-bold text-primary-2" style="margin-bottom: 4px;">
                      {{ getArchetypeDisplayName(getArchetypeReport(result._id)?.archetype?.primary || '') }}
                    </h4>
                    <small class="text-muted" *ngIf="getArchetypeReport(result._id)?.archetype?.secondary">
                      with {{ getArchetypeDisplayName(getArchetypeReport(result._id)?.archetype?.secondary || '') }} overlay
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-footer flex flex-vertical-center flex-wrap" style="gap: 8px;">
            <a class="btn btn-info btn-sm" [routerLink]="['/users', user['_id'], 'surveyResults', result._id]">
              <i class="fa fa-eye"></i>&nbsp;&nbsp;View result
            </a>
            <div class="flex-grow text-center text-muted">
              <i class="fa fa-calendar"></i>&nbsp;&nbsp;Completed on
              {{ result.updatedAt | date }}
            </div>
            <a
              *ngIf="hasArchetypeReport(result._id)"
              class="btn btn-warning btn-sm"
              [routerLink]="['/users', user['_id'], 'surveyResults', result._id, 'archetype']"
            >
              <i class="fa fa-star"></i>&nbsp;&nbsp;View IPSAT 2.0
            </a>
          </div>
        </div>
      </div>
      <!-- Pre-Coaching Worksheet. Ungated: the 2.0 worksheet is shared by     -->
      <!-- faith- and values-based users alike (per Steve 2026-08-06), so this -->
      <!-- replaces the older faith-only panel the 2.0 redesign removed.       -->
      <div class="col-md-12">
        <div class="hpanel">
          <div class="panel-body">
            <h4 class="font-bold m-t-none m-b-sm" style="color: var(--c-green-deep);">
              Prepare for your coaching session
            </h4>
            <p class="m-b-md">
              Take 10&ndash;15 minutes to complete the Pre-Coaching Worksheet
              before you meet with your coach. Your answers help the two of you
              make the most of your time together.
            </p>
            <a class="btn btn-success" href="/assets/files/IPSAT_Coaching_Prep_Worksheet.pdf" target="_blank"
              rel="noopener">
              <i class="fa fa-download"></i>&nbsp;&nbsp;Download the Pre-Coaching
              Worksheet (PDF)</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>